import { UI_Grid } from 'ui/components/4-habitats/Grid/Grid';
import type { UI_ServiceLinkCardProps } from 'ui/components/2-molecules/Card/ServiceLinkCard/ServiceLinkCard';
import styles from './ServiceLinkList.module.scss';
import { UI_ServiceLinkCard } from 'ui/components/2-molecules/Card/ServiceLinkCard/ServiceLinkCard';
import { UI_GridCell } from 'ui/components/4-habitats/Grid/GridCell';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import classNames from 'classnames';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_TopLevelGrid } from 'ui/components/4-habitats/TopLevelGrid/TopLevelGrid';
import { UI_TopLevelGridCell } from 'ui/components/4-habitats/TopLevelGrid/TopLevelGridCell';
import { UI_Kicker, UI_KickerProps } from 'ui/components/1-atoms/Kicker/Kicker';
import ColorOptions from 'helpers/types';
import { UI_LinkButton } from 'ui/components/1-atoms/Action/LinkButton/LinkButton';

export interface UI_ServiceLinkListProps {
	title?: string;
	items: UI_ServiceLinkCardProps[];
	link?: {
		url: string;
		target?: string;
		name?: string;
	};
	kicker?: UI_KickerProps;
	bgColor?: ColorOptions;
	globalTheme?: string;
	linkButtonStyle?: 'primary' | 'secondary';
}

export const UI_ServiceLinkList: React.FC<UI_ServiceLinkListProps> = ({ items, link, title, kicker, bgColor, globalTheme, linkButtonStyle }) => {
	return (
		<div className={classNames(styles.ServiceLinkList, `u-color___${bgColor}`)}>
			<UI_Container width="Standard">
				<UI_TopLevelGrid wrap container>
					<UI_TopLevelGridCell desktopWidth="16col" mobileWidth="100">
						{kicker && <UI_Kicker {...kicker} className={classNames(styles.ServiceLinkList_kicker, 'u-bottom-padding--xxl')} />}
						{title && (
							<UI_Heading headingLevel="h2" style="xl" className={styles.ServiceLinkList_heading}>
								{title}
							</UI_Heading>
						)}
					</UI_TopLevelGridCell>
					<UI_TopLevelGridCell
						desktopWidth="15col"
						desktopOffset="2col"
						offsetDirection="right"
						mobileWidth="100"
						className={styles.ServiceLinkList_grid}
					>
						<UI_Grid wrap={true}>
							{items.map((item, index) => (
								<UI_GridCell desktopWidth="50" mobileWidth="100" key={index} className={styles.ServiceLinkList_gridCell}>
									<UI_ServiceLinkCard {...item} key={index} className={styles.ServiceLinkList_card} />
								</UI_GridCell>
							))}
							{link && (
								<UI_GridCell desktopWidth="50" mobileWidth="100" className={styles.ServiceLinkList_btnContainer}>
									<UI_LinkButton style={linkButtonStyle} href={link.url} title={link.name} target={link.target} inheritsColor>
										{link.name}
									</UI_LinkButton>
								</UI_GridCell>
							)}
						</UI_Grid>
					</UI_TopLevelGridCell>
				</UI_TopLevelGrid>
			</UI_Container>
		</div>
	);
};
